var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Viewport',{attrs:{"rootMargin":((Math.abs(_vm.y)) + "px 0px")},on:{"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }